import Navbar from './components/Navbar.vue';


// Named export
export {
	Navbar,
}

// Default export
export default Navbar